import { Group, Station, User } from '@mi-front/core';
import { apiClient } from '../../../api';
import {
  GroupPermissionForStationState,
  GroupPermissionState,
  GroupPermissionUpdate,
  UserPermissionForStationState,
  UserPermissionState,
  UserPermissionUpdate,
} from '../types';

/**
 * Users
 */

export async function fetchUserPermissionsForAll(
  userId: string,
): Promise<readonly UserPermissionForStationState[]> {
  return apiClient.get(`/stations/users-permissions/${userId}`);
}

export function fetchUsersPermissions(stationId: string): Promise<UserPermissionState[]> {
  return apiClient.get(`/stations/${stationId}/users-permissions`);
}

export function updateUserPermission(
  stationId: Station['id'],
  data: UserPermissionUpdate,
): Promise<void> {
  return apiClient.put(`/stations/${stationId}/users-permissions/${data.userId}`, {
    allowed: data.allowed,
  });
}

export interface API_SetUsersPermissionsPayload {
  readonly permissions: {
    readonly userId: User['id'];
    //readonly permission?: null | ???;
  }[];
}

export function setUsersPermissions(idOrSlug: string, data: API_SetUsersPermissionsPayload) {
  return apiClient.post(`/stations/${idOrSlug}/users-permissions`, data);
}

/**
 * Groups
 */

export async function fetchGroupPermissionsForAll(
  groupId: string,
): Promise<readonly GroupPermissionForStationState[]> {
  return apiClient.get(`/stations/groups-permissions/${groupId}`);
}

export function fetchGroupsPermissions(stationId: string): Promise<GroupPermissionState[]> {
  return apiClient.get(`/stations/${stationId}/groups-permissions`);
}

export function updateGroupPermission(
  stationId: Station['id'],
  data: GroupPermissionUpdate,
): Promise<void> {
  return apiClient.put(`/stations/${stationId}/groups-permissions/${data.groupId}`, {
    allowed: data.allowed,
  });
}

export interface API_SetGroupsPermissionsPayload {
  readonly permissions: {
    readonly groupId: Group['id'];
    //readonly permission?: null | ???;
  }[];
}

export function setGroupsPermissions(idOrSlug: string, data: API_SetGroupsPermissionsPayload) {
  return apiClient.post(`/stations/${idOrSlug}/groups-permissions`, data);
}
